module.exports = __webpack_public_path__ + "assets/user-not-circle.b20da589.svg";